import React from "react";
import NavbarTop from "../NavbarTop";

import {
  module1_visits,
  module2_visits,
  module3_visits,
  module4_visits,
  module5_visits,
  module6_visits,
} from "../../firebase";

class Statistics extends React.Component {
  state = {
    Module1Visits: 0,
    Module2Visits: 0,
    Module3Visits: 0,
    Module4Visits: 0,
    Module5Visits: 0,
    Module6Visits: 0,
  };

  componentDidMount() {
    //module1_visits.add({ visits: 0 });
    this.getNumModuleVisits();
  }

  getNumModuleVisits = async () => {
    try {
      const visits = await module1_visits.get();
      visits.forEach((numVisits) => {
        this.setState({
          Module1Visits: numVisits.data().visits,
        });
      });
    } catch (error) {
      console.log("Error getting number of page visits", error);
    }
    try {
      const visits = await module2_visits.get();
      visits.forEach((numVisits) => {
        this.setState({
          Module2Visits: numVisits.data().visits,
        });
      });
    } catch (error) {
      console.log("Error getting number of page visits", error);
    }
    try {
      const visits = await module3_visits.get();
      visits.forEach((numVisits) => {
        this.setState({
          Module3Visits: numVisits.data().visits,
        });
      });
    } catch (error) {
      console.log("Error getting number of page visits", error);
    }
    try {
      const visits = await module4_visits.get();
      visits.forEach((numVisits) => {
        this.setState({
          Module4Visits: numVisits.data().visits,
        });
      });
    } catch (error) {
      console.log("Error getting number of page visits", error);
    }
    try {
      const visits = await module5_visits.get();
      visits.forEach((numVisits) => {
        this.setState({
          Module5Visits: numVisits.data().visits,
        });
      });
    } catch (error) {
      console.log("Error getting number of page visits", error);
    }
    try {
      const visits = await module6_visits.get();
      visits.forEach((numVisits) => {
        this.setState({
          Module6Visits: numVisits.data().visits,
        });
      });
    } catch (error) {
      console.log("Error getting number of page visits", error);
    }
  };
  render() {
    return (
      <div>
        <NavbarTop />
        <br />
        <br />
        <br />
        <div className="container-fluid row d-flex justify-content-center">
          <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12 "></div>
          <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12 ">
            <div className="card mb-4 box-shadow h-100 " id="pageContent_2">
              <ul className="list-group list-group-flush text-dark ">
                <li className="list-group-item form-card-1 ">
                  <div className="d-flex align-items-center">
                    <div className="p-2 w-100" id="moduleContentText">
                      <strong>I have no idea what I want to do</strong>
                    </div>
                    <div className="p-2" id="moduleContentText">
                      <h1>
                        <span className="badge badge-secondary">
                          {this.state.Module1Visits}
                        </span>
                      </h1>
                    </div>
                  </div>
                </li>
                <li className="list-group-item form-card-2 ">
                  <div className="d-flex align-items-center">
                    <div className="p-2 w-100" id="moduleContentText">
                      <strong>
                        I have some ideas and want to focus my thinking
                      </strong>
                    </div>
                    <div className="p-2" id="moduleContentText">
                      <h1>
                        <span className="badge badge-secondary">
                          {this.state.Module2Visits}
                        </span>
                      </h1>
                    </div>
                  </div>
                </li>
                <li className="list-group-item form-card-1 ">
                  <div className="d-flex align-items-center">
                    <div className="p-2 w-100" id="moduleContentText">
                      <strong>
                        I have changed my mind and need to rethink my plans
                      </strong>
                    </div>
                    <div className="p-2" id="moduleContentText">
                      <h1>
                        <span className="badge badge-secondary">
                          {this.state.Module3Visits}
                        </span>
                      </h1>
                    </div>
                  </div>
                </li>
                <li className="list-group-item form-card-2 ">
                  <div className="d-flex align-items-center">
                    <div className="p-2 w-100" id="moduleContentText">
                      <strong>
                        I know what I want to do but not sure how to get there
                      </strong>
                    </div>
                    <div className="p-2" id="moduleContentText">
                      <h1>
                        <span className="badge badge-secondary">
                          {this.state.Module4Visits}
                        </span>
                      </h1>
                    </div>
                  </div>
                </li>
                <li className="list-group-item form-card-1 ">
                  <div className="d-flex align-items-center">
                    <div className="p-2 w-100" id="moduleContentText">
                      <strong>I am ready to apply for a job or PhD</strong>
                    </div>
                    <div className="p-2" id="moduleContentText">
                      <h1>
                        <span className="badge badge-secondary">
                          {this.state.Module5Visits}
                        </span>
                      </h1>
                    </div>
                  </div>
                </li>
                <li className="list-group-item form-card-2 ">
                  <div className="d-flex align-items-center">
                    <div className="p-2 w-100" id="moduleContentText">
                      <strong>
                        I have a job, further study place or will be starting my
                        own business
                      </strong>
                    </div>
                    <div className="p-2" id="moduleContentText">
                      <h1>
                        <span className="badge badge-secondary">
                          {this.state.Module6Visits}
                        </span>
                      </h1>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12 ">
            <div className="card mb-4 box-shadow h-100 " id="pageContent_2">
              <ul className="list-group list-group-flush text-dark ">
                <li className="list-group-item  ">
                  <div className="d-flex align-items-center">
                    <div className="p-2 w-100" id="moduleContentText">
                      <h3>
                        <i>Total number of visits:</i>
                      </h3>
                    </div>
                    <div className="p-2" id="moduleContentText">
                      <h1>
                        <span className="badge badge-secondary">
                          {this.state.Module1Visits +
                            this.state.Module2Visits +
                            this.state.Module3Visits +
                            this.state.Module4Visits +
                            this.state.Module5Visits +
                            this.state.Module6Visits}
                        </span>
                      </h1>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Statistics;
